import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import BlockTypes from '../../types/BlockTypes';
import renderBlocks from '../utils/renderBlocks';
import { normalizeNode, shouldBeAtRoot } from '../utils/NormalizationHelper';
import Tile from './components/Tile';
export var schema = {
  blocks: _defineProperty({}, BlockTypes.INTEGRATION_TILE, {
    isVoid: true
  })
};
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === void 0 ? function (x) {
    return x;
  } : _ref$decorator;

  var Component = decorator(Tile);
  return [normalizeNode(BlockTypes.INTEGRATION_TILE, [shouldBeAtRoot]), {
    schema: schema
  }, renderBlocks(_defineProperty({}, BlockTypes.INTEGRATION_TILE, function (props) {
    return React.createElement(Component, props);
  }))];
});